<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_v"></a></p>
<p class="author"><strong>JACQUES DERRIDA</strong></p>
<h1 class="h1"><strong>The Animal That Therefore I Am</strong></h1>
<p class="center"><strong><em>Edited by Marie-Louise Mallet</em></strong></p>
<p class="center1"><strong>T<span class="small">RANSLATED BY</span> D<span class="small">AVID</span> W<span class="small">ILLS</span></strong></p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?5a024b98